import { UseCase } from '@/core/base/use-case';
import { SchedulesRequest } from '../models/schedules-request';
import { SchedulesResponse } from '../models/schedules-response';
import { LocationsRepository } from '../repositories/locations.respository';
import { Observable } from 'rxjs';

export class FindSchedulesUseCase
    implements UseCase<SchedulesRequest, SchedulesResponse>
{
    constructor(private readonly repository: LocationsRepository) {}

    execute(schedulesRequest: SchedulesRequest): Observable<SchedulesResponse> {
        return this.repository.findSchedules(schedulesRequest);
    }
}
